// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /feed/upcoming.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeFeedUpcomingBody,
  typeFeedUpcomingOutput200,
} from "../../sdk/feed/postFeedUpcoming";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildFeedUpcomingQueryKey(
  payload: typeFeedUpcomingBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueIds:${JSON.stringify(payload.leagueIds)}`);
  queryKeySegments.push(
    `perLeagueLimit:${JSON.stringify(payload.perLeagueLimit)}`,
  );
  queryKeySegments.push(`windowDays:${JSON.stringify(payload.windowDays)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  if (typeof payload.teamIds !== "undefined") {
    queryKeySegments.push(`teamIds:${JSON.stringify(payload.teamIds)}`);
  }
  return ["post:feed:feedUpcoming", "svc:events-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeFeedUpcomingOutput200,
    unknown,
    typeFeedUpcomingOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useFeedUpcoming(
  payload: typeFeedUpcomingBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildFeedUpcomingQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postFeedUpcoming(payload),
    ...resolvedOptions,
  });
}
